import React from 'react';
import { ScanLine, Handshake, Award, CalendarClock } from 'lucide-react';

const FeatureCard = ({ Icon, title, description }) => {
  return (
    <div
      className="p-[18px] sm:p-9 rounded-[10px] border bg-white shadow-[0_0_55.6px_0_rgba(0,0,0,0.04)] border-[#f5f5f5] font-montserrat" >
      <div className="flex flex-col sm:flex-row gap-[18px] sm:gap-5">
        <div className="flex-shrink-0">
          <Icon
            className="w-[54px] h-[57px] text-[var(--color-charcoal)]"
            strokeWidth={1.15}
            aria-hidden
          />
        </div>
        <div className="flex-1">
          <h3
            className="mb-3 text-[18px] sm:text-[24px]"
            style={{
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 700,
              lineHeight: '26.40px',
              color: 'var(--color-charcoal)'
            }}
          >
            {title}
          </h3>
          <p
            className='text-[12px] sm:text-[14px]'
            style={{
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 500,
              letterSpacing: '-0.28px',
              lineHeight: '22px',
              color: 'var(--color-charcoal)'
            }}
          >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default function FeaturesSection() {
  const features = [
    {
      Icon: ScanLine,
      title: 'Scan. Shape. Support.',
      description:
        "Your tree is built from SaddleFit 3D data—not guesswork—so pressure is distributed the way your horse's back actually carries the saddle."
    },
    {
      Icon: Handshake,
      title: 'Your saddle maker stays yours',
      description:
        'Order the tree through SaddleFit and partner with the maker you want. No middleman telling you who to use or how fast to move.'
    },
    {
      Icon: Award,
      title: 'A foundation worth building on',
      description:
        'A well-mapped tree gives your maker a true starting point, so leather and panels do their job instead of compensating for a generic form.'
    },
    {
      Icon: CalendarClock,
      title: 'Built for seasons, not photo day',
      description:
        'When fit is dialed to your horse, comfort and performance hold up ride after ride—exactly what SaddleFit is built to protect.'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-20">
        {/* Heading */}
        <div className="flex flex-col items-center mb-12">
          <h2
            className="text-center uppercase mb-6 font-bold font-barlowCondensed leading-[96%] tracking-[-0.03em] sm:mb-[29px] text-[36px] sm:text-[62px]"
            style={{
              color: 'var(--color-primary)'
            }}
          >
            Why the right tree matters
          </h2>
          <div
            className="w-full max-w-[370px] border-t-2 border-dashed"
            style={{
              borderColor: 'var(--color-accent-brown)'
            }}
          ></div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              Icon={feature.Icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
